/** Generated from tokens.css by scripts/pwa-colors.mjs. */
export const PWA_THEME_COLOR = '#18bf95';
